<p-progressSpinner *ngIf="isLoading$ | async"></p-progressSpinner>
<div *ngIf="(isLoading$ | async) === false">
  <p *ngIf="isBinary" class="m-3 text-600">
    This file is not text, so it can't be displayed here. Download it to open it.
  </p>
  <p *ngIf="truncated" class="m-3 text-600">
    This file is large; only the first 1,000,000 characters are shown.
  </p>
  <div *ngIf="content" id="json_code" class="code" styleClass='preview'>
    <!-- <pre> keeps its whitespace, so <code> must follow it with nothing between -->
    <pre *ngIf="highlightLanguages.length; else plain"><code
      [highlight]="content" [languages]="highlightLanguages"></code></pre>
    <ng-template #plain><pre><code>{{ content }}</code></pre></ng-template>
  </div>
</div>
